<template>
	<div>
		<HeaderAuth />
		<div class="container">
			<h2 v-if="isSuccess" class="title success">
				{{ 'Changes saved' | translate }}
			</h2>
			<h2 v-else class="title">{{ 'Password recovery' | translate }}</h2>

			<div v-if="isSuccess" class="form">
				<button class="btn btn-primary" @click="$router.push('/')">
					{{ 'Home' | translate }}
				</button>
			</div>
			<div v-else class="form">
				<input
					v-model="password.value"
					class="form-control"
					type="text"
					:placeholder="'Type your new password here' | translate"
				/>
				<p class="has-error mt-0" v-show="password.error">
					{{ password.error }}
				</p>

				<button class="btn btn-primary" @click="handleReset">
					{{ 'Set new password' | translate }}
				</button>
				<p class="has-error" v-show="globalError">{{ globalError }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import HeaderAuth from '@/components/UserAuth/HeaderAuth'

export default {
	components: {
		HeaderAuth,
	},
	name: 'sign-page',
	data() {
		return {
			isSuccess: false,
			globalError: null,
			password: {
				value: '',
				error: null,
			},
		}
	},
	methods: {
		resetErrors() {
			this.globalError = null
			this.password.error = null
		},

		handleReset() {
			this.resetErrors()
			this.loading = true
			const variables = {
				password: this.password.value,
				token: this.$route.query.token,
			}
			fetch('https://api.dev.indigomental.com/v1/users/user/restore/confirm', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(variables),
			})
				.then(res => res.json())
				.then(result => {
					if (result.detail) {
						this.globalError = result.detail
					}
					if (result.password) {
						if (Array.isArray(result.password)) {
							this.password.error = result.password.join('\n')
						}
						if (typeof result.password === 'string') {
							this.password.error = result.password
						}
					}
					if (result.status === 'OK') {
						this.isSuccess = true
					}
				})
				.catch(e => {
					this.globalError = e.message
				})
				.finally(() => (this.loading = false))
		},
	},
	beforeMount() {
		if (this.$route.query?.token) {
		} else {
			this.$router.push('/')
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.has-error {
	color: red;
	text-align: center;
	margin-top: 20px;
}

.success {
	color: green;
}

.form {
	max-width: 500px;
	margin: 40px auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.btn-primary {
	background-color: #e69c50;
	margin: 0 auto;
}

.title {
	text-align: center;
	margin-top: 30px;
	margin-bottom: 30px;
	font-size: 36px;
}

.small-page main p {
	font-size: 24px;
	margin: 30px 0;
	color: #fff;
}

input.form-control {
	margin: 15px 0px;
	text-align: center;
}

.form-group {
	text-align: left;
}

.form-group a {
	float: right;
	margin-top: 6px;
	color: #fff;
}
</style>
